import { Subscription, timer } from 'rxjs';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { AsyncPipe } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressBar } from '@angular/material/progress-bar';
import { ApplicantsFacade } from '../../../modules/admin-features/components/applicants/applicants.facade';
import { CountySelectionController } from '../../../shared/county-selection/county-selection.controller';

@Component({
  selector: 'app-intake-form-county-select',
  standalone: true,
  imports: [AsyncPipe, MatSelectModule, MatProgressBar],
  templateUrl: './intake-form-county-select.component.html',
  styleUrl: './intake-form-county-select.component.scss',
})
export class IntakeFormCountySelectComponent implements OnInit, OnDestroy {
  @Input() form: UntypedFormGroup;
  @Input() zipCodeControl: AbstractControl;
  @Input() label = 'County';
  @Input() countyControl: AbstractControl;
  @Input() fipsControlName = 'fipsCode';
  @Input() placeholder = '';
  field: CountySelectionController;
  private pendingLoad: Subscription;

  constructor(private readonly applicantsFacade: ApplicantsFacade) {}
  ngOnInit(): void {
    this.field = new CountySelectionController(
      this.form,
      this.zipCodeControl,
      this.countyControl,
      this.form.get(this.fipsControlName),
      this.form.get('state'),
      zip => this.applicantsFacade.getCountyByZipCode(zip),
      'label',
    );
    this.pendingLoad = timer(0).subscribe(() => this.field.load());
  }
  ngOnDestroy(): void {
    this.pendingLoad?.unsubscribe();
    this.field?.destroy();
  }
}
